import { render } from "./ClientsList.vue?vue&type=template&id=24846833"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"

import "./ClientsList.vue?vue&type=style&index=0&id=24846833&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__